

export * from '@lazy-cjk/jp-table-convert';
import m from '@lazy-cjk/jp-table-convert';

/**
 * Created by user on 2017/12/24/024.
 *
 * this module only do the char is exists in jp, zht, zhs
 * so don't use this module when u wanna fully zht <=> zhs
 *
 * 目前只支援 簡繁日漢字 並非全 cjk 漢字支援
 */
export default m;
